<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-md shadow-2xl w-full max-w-xl max-h-screen overflow-y-auto p-4"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div class="flex justify-between items-center border-b p-3">
            <p class="text-base">Edit A Leave Workflow</p>
            <img
              class="h-6 cursor-pointer bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close"
            />
          </div>

          <div
            v-if="create_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ create_error }}
          </div>
          <div
            v-if="create_success"
            class="p-1 text-center text-white text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Workflow Name</label>
              <input
                v-model="info.Name"
                type="text"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1 capitalize">Company</label>
              <select
                v-model="info.Location"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="setBranches"
              >
                <option
                  v-for="location in locations"
                  :key="location.Id"
                  :value="location.Name"
                >
                  {{ location.Name }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1 capitalize">Branch</label>
              <select
                v-model="info.Branch"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
                @change="setDepartments"
                :disabled="!info.Location"
              >
                <option
                  v-for="branch in branchesToSelect"
                  :key="branch.Id"
                  :value="branch.Name"
                >
                  {{ branch.Name }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Department</label>
              <el-select
                filterable
                class="bg-gray-200 rounded-full w-full border-none"
                v-model="info.Department"
                placeholder="Select a type"
                :disabled="!info.Branch"
                @change="getDepartmentId"
              >
                <el-option
                  v-for="department in departmentsToSelect"
                  :key="department.Name"
                  :label="department.Name"
                  :value="department.Name"
                />
              </el-select>
              <small
                v-if="info.BranchId && branchesToSelect.length === 0"
                class="text-sm italic text-yellow-600"
              >
                No departments at this branch
              </small>
            </div>

            <div class="text-sm">
              <label class="block text-sm mb-2" for="consecutive-switch">
                Any Can Approve
              </label>
              <div class="flex items-center bg-gray-200 rounded-md p-2">
                <input
                  id="consecutive-switch"
                  type="checkbox"
                  class="cursor-pointer form-checkbox h-5 w-5 text-blue-600"
                  v-model="info.AnyCanApprove"
                />
                <label for="consecutive-switch" class="ml-2 block text-sm">
                  Allow Any Approver to Approve
                </label>
              </div>
            </div>

            <div class="flex justify-end pt-4">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';

export default {
  name: 'CompanySetupEditLeaveWorkflow',
  props: ['showEditWorkflow', 'getWorkflow', 'info'],
  components: { Loader },
  data() {
    return {
      create_error: null,
      create_success: null,
      loading: false,
      employees: [],
      departments: [],
      locations: [],
      selectedEmployees: [],
      departmentsToSelect: [],
      branchesToSelect: [],
      branches: [],
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
  },
  watch: {
    showEditWorkflow(newVal) {
      if (newVal && this.info?.Location) this.setBranches();
      if (newVal && this.info?.Branch) this.setDepartments();
    },
  },
  created() {
    this.getLocations();
    this.getDepartments();
    this.getEmployees();
    this.getBranches();
  },
  methods: {
    setBranches() {
      this.info.Branch = '';
      this.info.Department = '';
      this.branchesToSelect = this.branches.filter(
        (branch) => branch.Location === this.info.Location
      );
    },
    setDepartments() {
      this.departmentsToSelect = this.departments.filter(
        (dept) =>
          dept.BranchName === this.info.Branch &&
          dept.LocationName === this.info.Location
      );
      const branchMatch = this.branchesToSelect.find(
        (b) => b.Name === this.info.Branch
      );
      this.info.BranchId = branchMatch ? branchMatch.Id : null;
    },
    getDepartmentId(name) {
      const match = this.departments.find((d) => d.Name === name);
      this.info.DepartmentId = match ? match.DepartmentId : null;
    },
    close() {
      this.$emit('close');
    },
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      const locationMatch = this.locations.find(
        (loc) => loc.Name === this.info.Location
      );
      this.info.LocationId = locationMatch ? locationMatch.Id : null;

      axios
        .put(
          `${this.getOrganization}/setup/leave/workflow/group/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then((response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.create_success = response.data.StatusMessage;
            this.$emit('closeOnSuccess');
            this.selectedEmployees = [];
            setTimeout(() => {
              this.create_success = null;
              this.close();
            }, 2500);
            this.getWorkflow();
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.create_error = error.message;
          setTimeout(() => {
            this.create_error = null;
          }, 2500);
        });
    },
    getEmployees() {
      this.loading = true;
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          { headers: { Authorization: `Bearer ${this.getToken}` } }
        )
        .then((res) => {
          this.loading = false;
          if (res.data.StatusCode === 200) {
            this.employees = res.data.Data;
            this.$store.commit('setEmployees', res.data.Data);
          } else {
            this.create_error = res.data.StatusMessage;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.create_error = err.message;
        });
    },
    getDepartments() {
      this.loading = true;
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          { headers: { Authorization: `Bearer ${this.getToken}` } }
        )
        .then((res) => {
          this.loading = false;
          if (res.data.StatusCode === 200) {
            this.departments = res.data.Data;
          } else {
            this.create_error = res.data.StatusMessage;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.create_error = err.message;
        });
    },
    getLocations() {
      this.loading = true;
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          { headers: { Authorization: `Bearer ${this.getToken}` } }
        )
        .then((res) => {
          this.loading = false;
          if (res.data.StatusCode === 200) {
            this.locations = res.data.Data;
          } else {
            this.create_error = res.data.StatusMessage;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.create_error = err.message;
        });
    },
    getBranches() {
      this.loading = true;
      axios
        .get(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
          { headers: { Authorization: `Bearer ${this.getToken}` } }
        )
        .then((res) => {
          this.loading = false;
          if (res.data.StatusCode === 200) {
            this.branches = res.data.Data;
          } else {
            this.create_error = res.data.StatusMessage;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.create_error = err.message;
        });
    },
  },
};
</script>

<!-- <style scoped>
/* Add any specific styling here if needed */
</style> -->

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.selected-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0.5rem 0;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  overflow-y: auto;
  max-height: 10rem;
}

.dropdown-menu label {
  display: block;
  padding: 0.5rem;
  cursor: pointer;
}

.dropdown-menu input[type='checkbox'] {
  margin-right: 0.5rem;
}

.dropdown-menu label:hover {
  background-color: #f7fafc;
}

.dropdown-menu label:last-of-type {
  margin-bottom: 0;
}

.dropdown-menu::-webkit-scrollbar {
  width: 0.25rem;
}

.dropdown-menu::-webkit-scrollbar-track {
  background-color: #f7fafc;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
}
</style>
